module.exports = __webpack_public_path__ + "static/media/calendar.23eebbd2.png";